export default function AtlasViewerIcon() {
	return (
		<svg id="atlasViewerIcon" data-name="AtlasViewer Icon" viewBox="0 0 32 32">
			<rect
				className="atlasViewerBG"
				y="0"
				width="32"
				height="32"
				rx="4"
				ry="4"
			/>
			<path
				className="whiteFill"
				d="M14.30203,10.9076l6.08064-6.08064c-3.58687-1.40514-7.71271-1.02013-11.00216,1.15912l4.92152,4.92152Z"
			/>
			<path
				className="whiteFill"
				d="M10.90762,14.30201l-4.92152-4.92152c-2.17928,3.28948-2.5643,7.4153-1.15915,11.00219l6.08067-6.08067Z"
			/>
			<path
				className="whiteFill"
				d="M26.01236,22.61794c3.08706-4.65968,2.57828-10.9993-1.52714-15.10472l-6.78879,6.78879,8.31592,8.31593Z"
			/>
			<path
				className="whiteFill"
				d="M14.30203,17.69642l-6.78881,6.78882c4.10542,4.10542,10.44506,4.61418,15.10474,1.52711l-8.31592-8.31593Z"
			/>
		</svg>
	)
}
